<template>
  <div class="base-wrapper" v-if="baseData">
    <!-- 音乐 -->
    <div class="music-wrap" @click="musicToggle" v-if="hasMusic">
      <audio
        id="bg_music"
        loop
        :src="baseData.music.musicUrl"
        @play="audioPlay"
        @pause="audioPause"
      ></audio>
      <img
        class="music-img"
        :class="[musicFlag && 'music-on-img']"
        :src="
          musicFlag
            ? 'http://wapcdn.thecover.cn/activity/annual/music_on.png'
            : 'http://wapcdn.thecover.cn/activity/annual/music_off.png'
        "
        alt=""
      />
    </div>
    <!-- 引流弹窗 -->
    <div
      class="activity-download-pop"
      v-if="(baseData.isAppShow || openDownLoadFlag) && !isApp"
    >
      <div class="activity-download-pop-inner">
        <p>参加该活动需在{{ appName }}APP中进行</p>
        <span
          @click="downLoadApp"
          data-trackevent="click"
          data-tracklabel="下载"
          data-track="track"
          >确认</span
        >
      </div>
    </div>
    <!-- 活动结束 -->
    <div class="activity-end" v-if="baseData.isEnd">
      <img
        src="https://wapcdn.thecover.cn/activity/public/activity_end_1.0.0.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import CONFIG from "../utils/config";
import WX from "wechat-js-sdk";
import COVERAPP from "../utils/COVERAPP";
import COVER from "../utils/COVER";

import { mapState } from "vuex";

export default {
  data() {
    return {
      id: "",
      hasMusic: false,
      musicFlag: true,
      audioDom: null,
      isApp: false,
	  appName: '',
    };
  },
  props: ["baseData", "activityData"],
  computed: {
    ...mapState(["openDownLoadFlag"]),
  },
  created() {
    this.id = this.$route.query.id || "";
    let baseData = this.baseData;
    this.hasMusic = !!(
      baseData.music &&
      baseData.music.isShow &&
      baseData.music.musicUrl
    );
    this.isApp = COVERAPP.Attribute.isApp() || COVERAPP.Attribute.isTFUnion();
    // 重定向新的地址
    if (this.activityData && this.activityData.redirectToUrl) {
      window.location.href = this.activityData.redirectToUrl;
    }
  },
  mounted() {
    COVER.isWapHidden();
    this.share();
    if (this.hasMusic) {
      this.audioAutoPlay();
    }
    this.setTrack();
	this.appName = CONFIG.APPNAME || '';
  },
  methods: {
    //分享
    share() {
      const id = this.id;
      let data = this.baseData.share;
      let shareData = {
        title: data.title,
        desc: data.desc,
        imgUrl: data.imgUrl,
        link: data.link || window.location.href,
        callback() {
          const img = new Image();
          img.src = CONFIG.ACTIVITY_URL + "/activity/share?aid=" + id;
          img.onload = function () {
            console.log("分享");
          };
        },
      };
      COVER.share(shareData);
    },
    //音乐自动播放
    audioAutoPlay() {
      let _this = this,
        doc = document;
      _this.audioDom = doc.getElementById("bg_music");
      _this.audioDom.play();
      //微信自动播放
      if (COVERAPP.Attribute.isWeixin()) {
        doc.addEventListener("WeixinJSBridgeReady", () => {
          _this.musicFlag && _this.audioDom.play();
        });
        // app自动播放
      } else if (COVERAPP.Attribute.isApp()) {
        COVERAPP.Method.GetUser({
          callback(res) {
            _this.musicFlag && _this.audioDom.play();
          },
        });
        // ios触摸自动播放
      } else {
        doc.addEventListener("touchstart", () => {
          _this.musicFlag && _this.audioDom.play();
        });
      }
    },
    //音乐播放
    audioPlay() {
      this.musicFlag = true;
    },
    //音乐暂停
    audioPause() {
      this.musicFlag = false;
    },
    // 音乐状态切换
    musicToggle() {
      this.musicFlag = !this.musicFlag;
      if (this.musicFlag) {
        this.audioDom.play();
      } else {
        this.audioDom.pause();
      }
    },
    //下载APP
    downLoadApp() {
      const activityData = this.activityData || {};
      if (activityData.trackTitle && activityData.trackUrl) {
        try {
          COVER.copyToClipborad(`${ activityData.trackTitle } ${ activityData.trackUrl } 打开封面新闻APP查看`);
          COVER.userTrack(this.id);
        }
        catch(err) {
          console.log(err);
        }
      }
      const data = this.baseData;
      const img = new Image();
      img.src = CONFIG.ACTIVITY_URL + "/activity/download?aid=" + this.id;
      img.onload = function () {
        console.log("下载");
      };
      COVER.$getScript(CONFIG.DOWNLOAD_ADDRESS).then(() => {
        COVER.downloadApp(this.id, data.flag, data.news_id);
      }).catch((err) => {
        console.error(err);
        COVER.downloadApp(this.id, data.flag, data.news_id);
      });
    },
    //埋点
    setTrack() {
      document.addEventListener(
        "touchstart",
        (e) => {
          let currentDom = e.target;
          if (currentDom.getAttribute("data-track")) {
            let event = currentDom.getAttribute("data-trackevent"),
              label = currentDom.getAttribute("data-tracklabel");
            COVER.track(this.id, event, label);
          }
        },
        false
      );
    },
  },
};
</script>

<style lang="less" scoped>
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.music-wrap {
  height: 1rem;
  position: fixed;
  right: 0.3rem;
  top: 1.2rem;
  width: 1rem;
  z-index: 11;
  audio {
    display: none;
  }
  .music-on-img {
    animation: rotating 1.2s linear infinite;
  }
}

.activity-download-pop {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 5;
  .activity-download-pop-inner {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    width: 6.5rem;
    padding: 0.5rem;
    background-color: #fff;
    border-radius: 0.2rem;
    box-sizing: border-box;
    font-size: 0.45rem;
    text-align: center;
    p {
      color: #474747;
      line-height: 1.3;
    }
    span {
      display: inline-block;
      min-width: 3.3rem;
      text-align: center;
      color: #fff;
      line-height: 1rem;
      padding: 0 0.3rem;
      background-color: #e62f17;
      margin: 0.3rem 0 0.1rem;
      border-radius: 0.2rem;
      letter-spacing: 0.1rem;
      box-sizing: border-box;
    }
  }
}

.activity-end {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 10;
  img {
    position: absolute;
    bottom: 0;
  }
}
</style>